export default __webpack_public_path__ + "vectors/direction.svg?d7bca615";